import { TeamState } from '@prophecy/graphql-types/enums';

import { ProfessionalMeteringInfo, PLAN_TYPES, ProfessionalCreditsBreakdown, CustomerBalance } from './types';

const DEFAULT_CREDITS_BREAKDOWN: ProfessionalCreditsBreakdown = {
  additionalUsersCredits: 0,
  dataEgressedCredits: 0,
  dataProcessedCredits: 0,
  dataStoredCredits: 0,
  computeCredits: 0,
  aiRequestsCredits: 0
};

export const DEFAULT_PROFESSIONAL_METERING_INFO: ProfessionalMeteringInfo = {
  userID: '',
  teamID: '',
  teamName: '',
  teamState: TeamState.disabled,
  plan: PLAN_TYPES.Starter,
  totalCreditsAllocated: 0,
  creditsConsumed: 0,
  serviceCreditsAllocated: 0,
  serviceCreditsConsumed: 0,
  userCreditsConsumed: 0,
  creditsBreakdown: DEFAULT_CREDITS_BREAKDOWN,
  availableCredits: 0,
  from: '',
  to: '',
  creditsCostPerAIRequest: 0,
  creditsCostPerCPUHour: 0,
  creditsCostPerGBStoredPerMonth: 0,
  creditsCostPerGBEgressed: 0,
  creditsCostPerUserPerMonth: 0,
  totalUsers: 0,
  activatedUsers: 0,
  includedUsers: 0,
  additionalUsers: 0,
  proratedUsers: 0,
  pricePerCredit: 0,
  usageLimit: {},
  updated_at: new Date().toISOString(),
  autoUpgraded: false
};

export const DEFAULT_CUSTOMER_BALANCE: CustomerBalance = {
  outstandingBalance: 0,
  creditBalance: 0,
  creditsBreakdown: DEFAULT_CREDITS_BREAKDOWN,
  serviceCreditsConsumed: 0,
  userCreditsConsumed: 0
};
